export default "__VITE_ASSET__DvVFinxL__"